import { AxiosRequestConfig } from 'axios';
import API from '../API';
import Questionnaire from '../../models/Questionnaire';

export const getQuestionnaireForCustomer = (
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
) => API.makeGetRequest('/questionnaire', queryParams, options) as Promise<Questionnaire[]>;